import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../../public/locales/en/common.json";
import translationES from "../../public/locales/es/common.json";
import translationPT from "../../public/locales/pt/common.json";
import translationFR from "../../public/locales/fr/common.json";
import translationJA from "../../public/locales/ja/common.json";
import partnersEN from "../../public/locales/en/partners.json";
import partnersES from "../../public/locales/es/partners.json";
import partnersPT from "../../public/locales/pt/partners.json";
import partnersFR from "../../public/locales/fr/partners.json";
import partnersJA from "../../public/locales/ja/partners.json";
import blogEN from "../../public/locales/en/blog.json";
import blogES from "../../public/locales/es/blog.json";
import blogPT from "../../public/locales/pt/blog.json";
import blogFR from "../../public/locales/fr/blog.json";
import blogJA from "../../public/locales/ja/blog.json";
import routesEN from "../../public/locales/en/routes.json";
import routesES from "../../public/locales/es/routes.json";
import routesPT from "../../public/locales/pt/routes.json";
import routesFR from "../../public/locales/fr/routes.json";
import routesJA from "../../public/locales/ja/routes.json";
import industryHealthcareEN from "../../public/locales/en/industry-healthcare.json";
import industryHealthcareES from "../../public/locales/es/industry-healthcare.json";
import industryHealthcarePT from "../../public/locales/pt/industry-healthcare.json";
import industryHealthcareFR from "../../public/locales/fr/industry-healthcare.json";
import industryHealthcareJA from "../../public/locales/ja/industry-healthcare.json";

const resources = {
  en: {
    translation: translationEN,
    partners: partnersEN,
    blog: blogEN,
    routes: routesEN,
    "industry-healthcare": industryHealthcareEN,
  },
  es: {
    translation: translationES,
    partners: partnersES,
    blog: blogES,
    routes: routesES,
    "industry-healthcare": industryHealthcareES,
  },
  pt: {
    translation: translationPT,
    partners: partnersPT,
    blog: blogPT,
    routes: routesPT,
    "industry-healthcare": industryHealthcarePT,
  },
  fr: {
    translation: translationFR,
    partners: partnersFR,
    blog: blogFR,
    routes: routesFR,
    "industry-healthcare": industryHealthcareFR,
  },
  ja: {
    translation: translationJA,
    partners: partnersJA,
    blog: blogJA,
    routes: routesJA,
    "industry-healthcare": industryHealthcareJA,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "es", "pt", "fr", "ja"],
    ns: ["translation", "partners", "blog", "routes", "industry-healthcare"],
    defaultNS: "translation",
    debug: false,
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
